const Skeleton = ({ width = '100%', height = 16, borderRadius = 6, style = {} }) => (
  <div style={{
    width,
    height,
    borderRadius,
    background: 'linear-gradient(90deg, var(--border) 25%, var(--bg) 50%, var(--border) 75%)',
    backgroundSize: '200% 100%',
    animation: 'skeletonShimmer 1.4s infinite',
    ...style,
  }} />
);

export const SkeletonCard = ({ rows = 3 }) => (
  <div className="card">
    <Skeleton height={18} width="55%" style={{ marginBottom: 12 }} />
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} height={13} width={i === rows - 1 ? '70%' : '100%'} style={{ marginBottom: 8 }} />
    ))}
  </div>
);

export const SkeletonStat = () => (
  <div className="stat-card">
    <Skeleton height={36} width="60%" style={{ marginBottom: 8 }} />
    <Skeleton height={12} width="80%" />
  </div>
);

export const skeletonCss = `
  @keyframes skeletonShimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

export default Skeleton;
